// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img.image[data-v-5e5e50b9]{background-color:var(--body-bg);height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;width:100%}img.image.animate[data-v-5e5e50b9]{opacity:0;transition:opacity .3s linear}img.image.animate.loaded[data-v-5e5e50b9]{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
